import type { User } from '@talon/web/lib/api';

/**
 * Whether the user is a talent manager, from applying on (TM signup sets `is_talent_manager`). Admins,
 * support agents and performers see their own app even if the flag is set.
 */
export const isTalentManagerUser = (user?: Partial<User> | null): boolean => {
  if (!user?.id || user.is_admin || user.is_support_agent || user.performer_id) return false;
  return !!user.is_talent_manager;
};

/** Where the logo, and "Go to dashboard", take the user */
export const homeRouteFor = (user?: Partial<User> | null): string => {
  if (user?.performer_id) return '/performer-home';
  return isTalentManagerUser(user) ? '/talent-manager' : '/';
};
